import { FC } from 'react';
import { MarkerF } from '@react-google-maps/api';
import { typeHTHBuilding } from '@monorepo/models';

type propsType = {
    building: typeHTHBuilding;
    color?: string;
    onClickHandler?: () => void;
    label?: string;
};

export const HTHMarkerBuilding: FC<propsType> = ({ building, color, label, onClickHandler }) => {

    return (
        <MarkerF
            clickable={!!onClickHandler}
            icon={{
                scaledSize: new window.google.maps.Size(40, 40),
                url: `https://maps.google.com/mapfiles/ms/icons/${color ?? 'red'}-dot.png`
            }}
            label={label}
            onClick={() => onClickHandler?.()}
            position={building.coords!}
        />
    );
}
